var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "15px",
    viewBox: "0 0 8 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-M---Header-Menu-L2",
    transform: "translate(-20.000000, -100.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jewelry",
    transform: "translate(20.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    transform: "translate(4.000000, 9.130151) scale(-1, 1) translate(-4.000000, -9.130151) ",
    points: "0.688038551 2 0 2.69783967 6.59615306 9.20512925 0.00392044758 15.5539674 0.684118103 16.2603014 8 9.21395026"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.96a2056776f9778c4f17de425a879332.svg";
export { ForwardRef as ReactComponent };